$(document).ready(function () {
    $('.js-header-content-message-close').on('click', function (e) {
        $(this).closest('.category-top-banner').slideUp();
    });
});
